import styled from 'styled-components'
export const Wrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
`
export const Header = styled.header`
  background-color: #ffffff;
  width: 100%;
  font-family: Inter;
  padding: 1rem 1rem 1rem 16rem;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 1rem 1rem 1rem 2rem;
  }
`
export const ScreenNameStyled = styled.p`
  display: flex;
  align-self: center;
  justify-content: center;
  margin-right: '10px';
  font-family: 'Inter';
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.8rem;
  letter-spacing: 0em;
  @media (max-width: 768px) {
    align-self: center;
    font-size: 1.1rem;
  }
`
export const UserWrapper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`
export const User = styled.p`
  font-family: Inter;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.05rem;
  letter-spacing: 0em;
  margin-right: 1rem;
`

export const Button = styled.button`
  padding: 11px 13px;
  color: rgb(253, 249, 243);
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  background-color: #fe5c73;
  opacity: 0.8;
  border: none;
  border-radius: 3px;
  outline: 0;
  cursor: pointer;
  @media (max-width: 768px) {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: inherit;
    color: #fe5c73;
    margin-left: 20px;
    background-color: transparent;
    box-shadow: none;
    padding: 0;
    margin: 0;
  }

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
  :hover {
    opacity: 1;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.1);
  }
`

// export const NavLi = styled.li`
// display:flex;
// align-items: center;
// margin:2rem;

// `
export const HamburgerMenuStyled = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: inline-block;
  }
  z-index: 100;
`
